var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/OnlineAccessConstants.js').ActionTypes;
var OnlineAccessAPI = require('../apis/OnlineAccessAPI.js');

module.exports = {
    saveOnlineAccess: function (fieldId, componentId, fieldValue, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SAVE_ONLINE_ACCESS,
            fieldId: fieldId,
            componentId: componentId,
            fieldValue: fieldValue,
            index: index
        });
    },
    validatePin: function (data, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_PIN,
            index: index
        });
        OnlineAccessAPI.validatePin(data, index);
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/OnlineAccessActions.js